// Autoplay video: loads each section's muted video once the page has finished
// loading, or as soon as the section comes within a screen of the viewport,
// and plays it while at least a quarter of it is in view. Every Autoplay video
// section includes this file, so it can be executed several times per page;
// only create the singleton once.
(function () {
  if (window.VideoAutoplay) return;

  // Every root that's set up, so one whose section has left the page can be
  // cleaned up
  var roots = [];

  function setupSection(root) {
    var video = root.querySelector('video[data-src]');
    if (!video) return;

    var active = true;
    var loaded = false;
    var visible = false;
    var idleId = 0;
    var timer = 0;
    var near = null;

    // Plays while at least a quarter of it is in view, pauses when less is.
    // First, so a browser without IntersectionObserver throws before anything
    // else is set up, and the cover image stays.
    var view = new IntersectionObserver(function (entries) {
      if (!active) return;
      if (!root.isConnected) return cleanup();
      visible = entries[entries.length - 1].intersectionRatio >= 0.25;
      if (!loaded) return;
      if (visible) play();
      else video.pause();
    }, { threshold: 0.25 });

    function play() {
      // Without loop, a video that has finished stays on its last frame
      if (video.ended) return;
      var playing = video.play();
      // iOS Low Power Mode blocks autoplay, and pause() interrupts a pending
      // play(): either way the cover image stays until the video plays
      if (playing && playing.catch) playing.catch(function () {});
    }

    function load() {
      if (!active || loaded) return;
      if (!root.isConnected) return cleanup();
      stopWaiting();
      loaded = true;
      video.muted = true;
      video.preload = 'auto';
      video.src = video.getAttribute('data-src');
      if (visible) play();
    }

    // Window load comes after the LCP image; then wait for an idle moment.
    // Safari has no requestIdleCallback: a short pause instead.
    function onLoad() {
      if (window.requestIdleCallback) idleId = requestIdleCallback(load, { timeout: 2000 });
      else timer = setTimeout(load, 200);
    }

    function stopWaiting() {
      window.removeEventListener('load', onLoad);
      if (idleId) cancelIdleCallback(idleId);
      clearTimeout(timer);
      if (near) near.disconnect();
    }

    function onPlaying() {
      video.classList.add('is-shown');
    }

    function cleanup() {
      if (!active) return;
      active = false;
      stopWaiting();
      view.disconnect();
      video.removeEventListener('playing', onPlaying);
      // Stop the download: the theme editor replaces a section it re-renders
      if (loaded) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      roots.splice(roots.indexOf(root), 1);
      root._va = null;
    }

    root._va = { cleanup: cleanup };
    roots.push(root);
    video.addEventListener('playing', onPlaying);
    view.observe(root);

    // Straight away if the page has already loaded (the theme editor, a
    // re-render); otherwise after load, or as soon as the section comes within
    // a screen of the viewport
    if (document.readyState === 'complete') return load();
    window.addEventListener('load', onLoad);
    near = new IntersectionObserver(function (entries) {
      if (entries[entries.length - 1].isIntersecting) load();
    }, { rootMargin: '100% 0px' });
    near.observe(root);
  }

  // A section can leave the page with no unload event (a script swapping out
  // the content it's in): clean those up whenever another section sets up
  function init(root) {
    if (!root || !root.classList || !root.classList.contains('video-autoplay')) return;
    roots.slice().forEach(function (el) {
      if (!el.isConnected) el._va.cleanup();
    });
    if (!root._va) setupSection(root);
  }

  function rootsIn(el) {
    return el && el.querySelectorAll ? el.querySelectorAll('.video-autoplay') : [];
  }

  // Theme editor listeners, registered once for every instance on the page
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      Array.prototype.forEach.call(rootsIn(event.target), init);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(rootsIn(event.target), function (el) {
        if (el._va) el._va.cleanup();
      });
    });
  }

  window.VideoAutoplay = { init: init };

  // Set up any section whose own init didn't: in the theme editor, one whose
  // load event came before this file had run, or whose load of it failed
  if (document.readyState !== 'loading') {
    Array.prototype.forEach.call(document.querySelectorAll('.video-autoplay'), init);
  }
})();
